const SCAN_QUEUE_JOB = "rcb-scan";
const AUTOMATIC_SCAN_STATER_QUEUE_JOB = "rcb-automatic-scan-starter";
const DATABASE_CONSENT_MIGRATION_QUEUE_JOB = "rcb-db-consent-v2";
export { SCAN_QUEUE_JOB, AUTOMATIC_SCAN_STATER_QUEUE_JOB, DATABASE_CONSENT_MIGRATION_QUEUE_JOB };
